import { FC, useState } from "react";
import styled from "styled-components";

import Text from "@/components/Text";
import { ImageGenerationProjectResource } from "@/types/resources";
import Button from "@/components/Button";
import ImageToolMainForm from "@/pages/ImageToolCreate/components/ImageToolMainForm";

const Box = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  padding: 24px;
  margin-bottom: 56px;
`;

const Description = styled.div`
  padding-top: 24px;
  line-height: 22px;
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  font-size: 14px;
  margin-top: 24px;
  border-top: 1px solid ${({ theme }) => theme.colors.lightGray};
`;

const BoxHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Label = styled(Text)`
  margin-bottom: 4px;
`;

const EditButton = styled(Button)`
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  font-size: 14px;
  line-height: 22px;
  height: 38px;
  padding: 0 32px;
`;

const ArticleLinkBlock = styled.div`
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  a {
    white-space: nowrap;
  }
`;

interface Props {
  imageProject: ImageGenerationProjectResource;
}

const ImageToolContentBox: FC<Props> = ({ imageProject }) => {
  const [showEditForm, setShowEditForm] = useState(false);

  return (
    <>
      {showEditForm ? (
        <ImageToolMainForm
          hideForm={() => setShowEditForm(false)}
          project={imageProject}
        />
      ) : (
        <>
          <Box>
            <BoxHeader>
              <div>
                <Label $type="smallHeadline" $color="gray">
                  Project Name
                </Label>
                <Text $type="caption">{imageProject.name}</Text>
              </div>
              {!!imageProject.properties?.popnuggets_article_link && (
                <ArticleLinkBlock>
                  <Label $type="smallHeadline" $color="gray">
                    PopNuggets Article
                  </Label>
                  <Text
                    $type="caption"
                    href={imageProject.properties.popnuggets_article_link}
                    as="a"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    {imageProject.properties.popnuggets_article_link}
                  </Text>
                </ArticleLinkBlock>
              )}
              <EditButton
                color="secondary"
                onClick={() => setShowEditForm(true)}
              >
                Edit
              </EditButton>
            </BoxHeader>
            {imageProject.description && (
              <Description>{imageProject.description}</Description>
            )}
          </Box>
        </>
      )}
    </>
  );
};

export default ImageToolContentBox;
